import Snowfall from 'react-snowfall'
import SnowStorm from 'react-snowstorm';


export const getStyle = (dark) => {
  var backgroundColor = "rgba(240, 248, 255, .8)"
  if (dark) {
    backgroundColor = "rgba(33, 37, 41, 0.8)"
  }

  return {
    backgroundColor: backgroundColor,
    borderRadius: "25px",
    borderWidth: "thick",
    overflow: "auto",
    boxShadow: "0px 5px 10px DarkSlateGray",
  }
}


export const BWHeader = (dark, mainText, contentText) => (
  <>
    <div className="container">
      <div
        className="p-3"
        style={ getStyle(dark) }
      >
        <div className="container-fluid">
          <h1 className={ `display-5 fw-bold ${ dark ? "text-white" : "" }` }>
            { mainText }
          </h1>
          <br/>

          <h3 className={ `${ dark ? "text-white" : "" }` }>
            { contentText }
          </h3>
        </div>
      </div>
    </div>
  </>
);

export const center = (element) => {
  return (
    <div style={{ "display": "flex", "justifyContent": "center"}} >
      { element }
    </div>
  )
}

export const ConditionalSnow = (snowIsEnabled) => (
  snowIsEnabled ?
    (<>
      <SnowStorm
        excludeMobile={false}
        followMouse={false}
      />
      <Snowfall />
    </>)
    : <></>
)

export const space6 = (
  <>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
  </>
);

export const space3 = (
  <div>
    <br/>
    <br/>
    <br/>
  </div>
);


export const space18 = (
  <>
    { space6 }
    { space6 }
    { space6 }
  </>
);

